"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.AccountButtons = exports.Item = exports.RightHeadline = exports.MainList = exports.NavColumn = exports.Column = exports.SocialList = exports.MiscList = void 0;
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const router_1 = require("@reach/router");
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api"));
var facebookIcon = require("../../assets/images/icons/facebook.svg");
var instagramIcon = require("../../assets/images/icons/instagram.svg");
var vimeoIcon = require("../../assets/images/icons/vimeo.svg");
var pinterestIcon = require("../../assets/images/icons/pinterest.svg");
var rssIcon = require("../../assets/images/icons/rss.svg"); // Component
var SiteMap = function SiteMap(_ref) {
    var theme = _ref.theme, className = _ref.className;
    var _useGlobal = _store_1.default(function (state) {
        return state.user;
    }, function (actions) {
        return actions.signOut;
    }), user = _useGlobal[0], signOut = _useGlobal[1];
    var logout = function logout() {
        return _api_1.default('logout').then(function () {
            return signOut();
        });
    };
    var _useGlobal2 = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal2[1];
    var _useGlobal3 = _store_1.default(function (state) {
        return state.panel;
    }, function (actions) {
        return actions.setPanel;
    }), setPanel = _useGlobal3[1];
    var _useLocation = router_1.useLocation(), pathname = _useLocation.pathname;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, {
        theme: theme,
        className: className
    }, /*#__PURE__*/ react_1.default.createElement(StyledMargin, null, /*#__PURE__*/ react_1.default.createElement(exports.NavColumn, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(exports.MainList, null, /*#__PURE__*/ react_1.default.createElement(exports.Item, Object.assign({
        theme: theme
    }, {
        className: pathname.substr(1, 5) === 'about' ? 'active' : ''
    }), /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/about"
    }, "About")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/inspiration",
        className: pathname.substr(1, 11) === 'inspiration' ? 'active' : ''
    }, "Inspiration")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/experiences",
        className: pathname.substr(1, 11) === 'experiences' ? 'active' : ''
    }, "Experiences")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/destinations",
        className: pathname.substr(1, 12) === 'destinations' ? 'active' : ''
    }, "Destinations"))), /*#__PURE__*/ react_1.default.createElement(exports.MiscList, {
        theme: theme,
        pathname: pathname
    })), /*#__PURE__*/ react_1.default.createElement(exports.Column, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(exports.RightHeadline, {
        theme: theme
    }, "For the curious."), /*#__PURE__*/ react_1.default.createElement(exports.AccountButtons, null, !user && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(exports.StyledButton, Object.assign({
        onClick: function onClick() {
            setPanel('pricing');
            setVisibleDropdown('account');
        },
        type: theme === 'light' ? 'black' : 'white',
        shadow: true
    }, {
        theme: theme
    }), "Become a member"), /*#__PURE__*/ react_1.default.createElement(exports.StyledButton, Object.assign({
        onClick: function onClick() {
            return setVisibleDropdown('account');
        },
        type: "outline"
    }, {
        theme: theme
    }), "Sign In")), user && /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(exports.StyledButton, Object.assign({
        to: "/account",
        type: theme === 'light' ? 'black' : 'white',
        shadow: true
    }, {
        theme: theme
    }), "View Profile"), /*#__PURE__*/ react_1.default.createElement(exports.StyledButton, Object.assign({
        onClick: function onClick() {
            return logout();
        },
        type: "outline"
    }, {
        theme: theme
    }), "Sign Out")))), /*#__PURE__*/ react_1.default.createElement(exports.Column, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(exports.SocialList, {
        theme: theme
    }))));
};
exports.MiscList = function MiscList(_ref2) {
    var theme = _ref2.theme, pathname = _ref2.pathname;
    return /*#__PURE__*/ react_1.default.createElement(MicroList, null, /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/contact",
        className: pathname.substr(1, 7) === 'contact' ? 'active' : ''
    }, "Contact")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/press",
        className: pathname.substr(1, 5) === 'press' ? 'active' : ''
    }, "Press")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/terms-of-use",
        className: pathname.substr(1, 12) === 'terms-of-use' ? 'active' : ''
    }, "Terms")), /*#__PURE__*/ react_1.default.createElement(exports.Item, {
        theme: theme
    }, /*#__PURE__*/ react_1.default.createElement(gatsby_1.Link, {
        to: "/privacy-policy",
        className: pathname.substr(1, 14) === 'privacy-policy' ? 'active' : ''
    }, "Privacy")));
};
exports.SocialList = function SocialList(_ref3) {
    var theme = _ref3.theme;
    return /*#__PURE__*/ react_1.default.createElement(Social, null, /*#__PURE__*/ react_1.default.createElement(SocialItem, Object.assign({
        color: _theme_1.palette.facebook,
        logo: facebookIcon
    }, {
        theme: theme
    }), /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://www.facebook.com/prior.club/",
        target: "_blank",
        rel: "noopener",
        title: "Posts by PRIOR on Facebook"
    }, "Posts by PRIOR on Facebook")), /*#__PURE__*/ react_1.default.createElement(SocialItem, Object.assign({
        color: _theme_1.palette.instagram,
        logo: instagramIcon
    }, {
        theme: theme
    }), /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://instagram.com/prior",
        target: "_blank",
        rel: "noopener",
        title: "Photographs by PRIOR on Instagram"
    }, "Photographs by PRIOR on Instagram")), /*#__PURE__*/ react_1.default.createElement(SocialItem, Object.assign({
        color: _theme_1.palette.pinterest,
        logo: pinterestIcon
    }, {
        theme: theme
    }), /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://www.pinterest.com/priorclub/",
        target: "_blank",
        rel: "noopener",
        title: "Pinboards by PRIOR on Pinterest"
    }, "Pinboards by PRIOR on Pinterest")), /*#__PURE__*/ react_1.default.createElement(SocialItem, Object.assign({
        color: _theme_1.palette.vimeo,
        logo: vimeoIcon
    }, {
        theme: theme
    }), /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://vimeo.com/priorclub",
        target: "_blank",
        rel: "noopener",
        title: "Videos by PRIOR on Vimeo"
    }, "Videos by PRIOR on Vimeo")), /*#__PURE__*/ react_1.default.createElement(SocialItem, Object.assign({
        color: _theme_1.palette.rss,
        logo: rssIcon
    }, {
        theme: theme
    }), /*#__PURE__*/ react_1.default.createElement("a", {
        href: "https://prior.club/rss.xml",
        target: "_blank",
        title: "RSS news feed"
    }, "RSS news feed")));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "SiteMap__Wrapper",
    componentId: "il82n4-0"
})(["position:relative;display:flex;flex-direction:column;justify-content:center;background-color:", ";color:", ";padding:64px 0;", "{padding:80px 0;}", "{padding:96px 0;}", "{padding:128px 0;}"], function (props) {
    return props.theme === 'light' ? _theme_1.palette.snow : _theme_1.palette.ink;
}, function (props) {
    return props.theme === 'light' ? _theme_1.palette.ink : _theme_1.palette.snow;
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledMargin = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Margin, props);
}).withConfig({
    displayName: "SiteMap__StyledMargin",
    componentId: "il82n4-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;width:100%;", "{flex-direction:row;align-content:flex-start;justify-content:space-between;}"], _utils_1.mediaQuery('tablet'));
/* Columns */
exports.Column = styled_components_1.default.div.withConfig({
    displayName: "SiteMap__Column",
    componentId: "il82n4-2"
})(["width:100%;padding:32px 0;border-top:1px solid ", ";", "{width:calc(50% - 20px);padding:40px 0;}", "{padding:48px 0;}", "{width:calc(50% - 40px);padding:64px 0;}&:last-of-type{padding-bottom:0;}"], function (props) {
    return props.theme === 'light' ? _utils_1.rgba(_theme_1.palette.ink, 0.16) : _utils_1.rgba(_theme_1.palette.snow, 0.16);
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.NavColumn = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(exports.Column, props);
}).withConfig({
    displayName: "SiteMap__NavColumn",
    componentId: "il82n4-3"
})(["display:flex;flex-direction:row;align-items:top;justify-content:space-between;padding:28px 0;& > ul{flex:0 1 calc(50% - 20px);}", "{padding:36px 0;}", "{padding:40px 0;}", "{padding:56px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
/* Lists */
exports.MainList = styled_components_1.default.ul.withConfig({
    displayName: "SiteMap__MainList",
    componentId: "il82n4-4"
})(["", ""], _theme_1.type.h2);
var MicroList = styled_components_1.default.ul.withConfig({
    displayName: "SiteMap__MicroList",
    componentId: "il82n4-5"
})(["", " & > li > a{font-weight:600;}"], _theme_1.type.label);
exports.RightHeadline = styled_components_1.default.div.withConfig({
    displayName: "SiteMap__RightHeadline",
    componentId: "il82n4-6"
})(["", " text-shadow:", ";margin-bottom:24px;", "{margin-bottom:32px;}", "{margin-bottom:46px;}", "{margin-bottom:54px;}"], _theme_1.type.h2, function (props) {
    return props.theme === 'light' ? 'none' : '1px 1px 0px rgba(0, 0, 0, 0.16)';
}, _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.Item = styled_components_1.default.li.withConfig({
    displayName: "SiteMap__Item",
    componentId: "il82n4-7"
})(["& > a,& > span{position:relative;display:block;padding:4px 0;width:fit-content;overflow:hidden;text-shadow:", ";cursor:pointer;&::after{z-index:2;position:absolute;bottom:4px;left:0;background-color:", ";width:100%;height:1px;transform:translate3d(-100%,0,0);transition:color 0.25s ease-in-out,transform 0.35s ease-in-out;content:'';pointer-events:none;}&.active{color:", ";&::after{transform:translate3d(0,0,0);}}", "{&:hover{color:", ";&::after{transform:translate3d(0,0,0);}}}", "{padding:8px 0;&::after{bottom:6px;}}}"], function (props) {
    return props.theme === 'light' ? 'none' : '1px 1px 0px rgba(0, 0, 0, 0.16)';
}, function (props) {
    return props.theme === 'light' ? _utils_1.rgba(_theme_1.palette.brown, 0.64) : _utils_1.rgba(_theme_1.palette.rose, 0.64);
}, function (props) {
    return props.theme === 'light' ? _theme_1.palette.brown : _theme_1.palette.rose;
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.theme === 'light' ? _theme_1.palette.brown : _theme_1.palette.rose;
}, _utils_1.mediaQuery('laptop'));
/* Account Buttons */
exports.AccountButtons = styled_components_1.default.div.withConfig({
    displayName: "SiteMap__AccountButtons",
    componentId: "il82n4-8"
})(["display:flex;flex-direction:column;align-items:top;& > div{margin-bottom:16px;&:last-of-type{margin-bottom:0;}}", "{flex-direction:row;justify-content:space-between;& > div{flex:0 1 calc(50% - 16px);margin-bottom:0;}}", "{& > div{flex:0 1 calc(50% - 20px);}}"], _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
exports.StyledButton = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, props);
}).withConfig({
    displayName: "SiteMap__StyledButton",
    componentId: "il82n4-9"
})(["display:block;", " ", ""], function (props) {
    return props.theme !== 'light' && props.type === 'outline' && "\n    border-color: " + _utils_1.rgba(_theme_1.palette.snow, 0.64) + ";\n    span {\n      color: " + _theme_1.palette.snow + ";\n    }\n  ";
}, function (props) {
    return props.theme == 'light' && props.type === 'outline' && "\n    box-shadow: none;\n  ";
});
/* Social Buttons */
var Social = styled_components_1.default.ul.withConfig({
    displayName: "SiteMap__Social",
    componentId: "il82n4-10"
})(["display:flex;flex-direction:row;justify-content:center;& > li{margin-right:16px;}& > li:last-of-type{margin-right:0;}", "{justify-content:flex-start;& > li{margin-right:24px;}}"], _utils_1.mediaQuery('tablet'));
var SocialItem = styled_components_1.default.li.withConfig({
    displayName: "SiteMap__SocialItem",
    componentId: "il82n4-11"
})(["position:relative;display:block;background-color:", ";height:40px;width:40px;border-radius:50%;&::before{z-index:-1;position:absolute;top:0;bottom:0;left:0;right:0;border:20px solid ", ";border-radius:50%;transform:scale3d(0,0,1);transform-origin:center;opacity:0.6;content:'';}> a{display:block;background-color:", ";height:100%;mask-repeat:no-repeat;mask-position:center center;mask-size:18px auto;", " text-indent:-99999px;overflow:hidden;transition:background-color 0.25s ease-in-out;}", "{transform:translate3d(0,0,0) scale3d(1,1,1);transition:background-color 0.25s ease-in-out,transform 0.4s ease-in-out;will-change:background,transform;&:hover{background-color:", ";transform:translate3d(0,-2px,0) scale3d(1.05,1.05,1);& a{background-color:", ";}}&:hover::before{transition:opacity 0.8s ease-in-out,transform 0.8s ease-in-out;transform:scale3d(1.6,1.6,1);opacity:0;}}", "{height:48px;width:48px;&::before{border-width:24px;}> a{mask-size:20px auto;}}", "{height:64px;width:64px;&::before{border-width:32px;}> a{mask-size:24px auto;}}"], function (props) {
    return props.theme === 'light' ? _theme_1.palette.ink : _theme_1.palette.snow;
}, function (props) {
    return props.color;
}, function (props) {
    return props.theme === 'light' ? _theme_1.palette.snow : _theme_1.palette.ink;
}, function (props) {
    return props.logo && "\n      mask-image: url(" + props.logo + ");\n    ";
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.color;
}, _theme_1.palette.snow, _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Typing
// note: null should always be read as "dark"
exports.default = SiteMap;
